import { Component, OnInit } from '@angular/core';

import { CensoService } from '@app/shared/services/censo.service';

import { Censo } from '@app/shared/models';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  censo: Censo;

  constructor(private censoService: CensoService) { }

  ngOnInit(): void {
    this.censo = this.censoService.retornarSessionStorage('censo');
  }

}
